export default __webpack_public_path__ + "static/media/move_up_disabled.31fc773c.svg";